// Required Angular modules
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
// Required imports for the services
import { ServerBaseService } from './services/server-base.service';
import { ADMIN_API_SERVER_URL } from './services/tokens/admin-api-server-url.token';
import { EMS_API_SERVER_URL } from './services/tokens/ems-api-server-url.token';
// The actual services 
import { AccountService } from './services/account/account.service';
import { AspNetUserService } from './services/asp-net-user/asp-net-user.service';
import { ClientCountriesService } from './services/client-countries/client-countries.service';
import { CommodityService } from './services/commodity/commodity.service';
import { CurrencyService } from './services/currency/currency.service';
import { CountryService } from './services/country/country.service';
import { UnitSizeService } from './services/unitsize/unitsize.service';
import { CrawlerStatusService } from './services/crawler-status/crawler-status.service';
import { DispatchService } from './services/dispatch/dispatch.service';
import { ElasticSearchService } from './services/elastic-search/elasticsearch.service';
import { EmsService } from './services/ems/ems.service';
import { FinanceStatusService } from './services/finance-status/finance-status.service';
import { GeneralService } from './services/general/general.service';
import { NoteService } from './services/note/note.service';
import { OrderLineService } from './services/order-line/order-line.service';
import { OrderProcessingService } from './services/order-processing/order-processing.service';
import { ProductService } from './services/product/product.service';
import { ProductImagesService } from './services/product-images/product-images.service';
import { ProjectService } from './services/project/project.service';
import { PurchaseInvoiceService } from './services/purchase-invoice/purchase-invoice.service';
import { PurchasingQueryService } from './services/purchasing-query/purchasing-query.service';
import { QuickbooksService } from './services/quickbooks/quickbooks.service';
import { ShopDepartmentService } from './services/shop-department/shop-department.service';
import { StaffService } from './services/staff/staff.service';
import { StatusService } from './services/status/status.service';
import { SupplierService } from './services/supplier/supplier.service';
import { SupplierPreferenceService } from './services/supplier-preference/supplier-preference.service';

export {
  AccountService,
  AspNetUserService,
  ClientCountriesService,
  CommodityService,
  CurrencyService,
  CountryService,
  CrawlerStatusService,
  DispatchService,
  ElasticSearchService,
  EmsService,
  FinanceStatusService,
  GeneralService,
  NoteService,
  OrderLineService,
  OrderProcessingService,
  ProductService,
  ProductImagesService,
  ProjectService,
  PurchaseInvoiceService,
  PurchasingQueryService,
  QuickbooksService,
  ShopDepartmentService,
  StaffService,
  StatusService,
  SupplierService,
  SupplierPreferenceService,
  UnitSizeService,
  ServerBaseService,
  ADMIN_API_SERVER_URL,
  EMS_API_SERVER_URL
};

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [],
  providers: [
    AccountService,
    AspNetUserService,
    ClientCountriesService,
    CommodityService,
    CurrencyService,
    CountryService,
    CrawlerStatusService,
    DispatchService,
    ElasticSearchService,
    EmsService,
    FinanceStatusService,
    GeneralService,
    NoteService,
    OrderLineService,
    OrderProcessingService,
    ProductService,
    ProductImagesService,
    ProjectService,
    PurchaseInvoiceService,
    PurchasingQueryService,
    QuickbooksService,
    ShopDepartmentService,
    SupplierService,
    StaffService,
    StatusService,
    SupplierPreferenceService,
    UnitSizeService
  ]
})
export class ServerModule {
}
